import React from 'react';
import moment from 'moment';
import styles from '../JobShiftPreStartView.module.css';

const formatSignedAt = (signedAt) => {
  if (!signedAt) {
    return '';
  }

  return moment.utc(signedAt).isValid() ? moment.utc(signedAt).format('DD/MM/YYYY') : '';
};

const getParticipantName = (submission = {}) => {
  if (submission && submission.added_on_the_fly && submission.added_person_name) {
    return submission.added_person_name;
  }

  return submission && submission.staff_name ? submission.staff_name : '';
};

const getParticipantRole = (submission = {}) => {
  if (submission && submission.added_on_the_fly && submission.added_person_role) {
    return submission.added_person_role;
  }

  return submission && (submission.job_title || submission.staff_role) ? (submission.job_title || submission.staff_role) : '';
};

const getParticipantPhone = (submission = {}) => {
  if (submission && submission.added_on_the_fly && submission.added_person_phone) {
    return submission.added_person_phone;
  }

  return submission && (submission.phone_number || submission.staff_phone) ? (submission.phone_number || submission.staff_phone) : '';
};

const getParticipantSignature = (submission = {}) => {
  if (submission && submission.signature && submission.signature.sign_url) {
    return submission.signature.sign_url;
  }

  return '';
};

export default function PreStartSignOff({ preStartData }) {

  const signOffHeadingContent = preStartData.prestart_staff_signoff || null;
  const supervisorSubmission = preStartData && preStartData.shift_answers
    ? preStartData.shift_answers.supervisor_submission || null
    : null;
  const workerSubmissions = preStartData && preStartData.shift_answers && Array.isArray(preStartData.shift_answers.worker_submissions)
    ? preStartData.shift_answers.worker_submissions
    : [];
  const signatoryRows = [
    ...(supervisorSubmission ? [supervisorSubmission] : []),
    ...workerSubmissions
  ];

  return (
    <div className={styles.PreviewSectionBlock}>
      <div className={styles.PreviewSectionHead}>
        <span className={styles.PreviewSectionNum}>4</span>
        Pre-Start Sign Off
      </div>
      <div className={styles.PreviewSectionBody}>
        {signOffHeadingContent && (
          <div className={`${styles.PreviewRichText} preview-swms-v3-authorization-rich-text`} dangerouslySetInnerHTML={{ __html: signOffHeadingContent || "" }}></div>
        )}
        <table className={styles.PreviewTable}>
          <thead>
            <tr>
              <th>Date</th>
              <th>Name</th>
              <th>Role</th>
              <th>Phone</th>
              <th>Signature</th>
            </tr>
          </thead>
          <tbody>
            {signatoryRows.length > 0 ? signatoryRows.map((submission, index) => {
              const signatureUrl = getParticipantSignature(submission);

              return (
                <tr key={`${submission && submission.staff_id ? submission.staff_id : 'submission'}-${index}`}>
                  <td>{formatSignedAt(submission && submission.signed_at) || <span>&mdash;</span>}</td>
                  <td><strong>{getParticipantName(submission) || <span>&mdash;</span>}</strong></td>
                  <td style={{ textTransform: 'capitalize' }}>{getParticipantRole(submission) || <span>&mdash;</span>}</td>
                  <td>{getParticipantPhone(submission) || <span>&mdash;</span>} </td>
                  <td>
                    {signatureUrl ? (
                      <img style={{ maxWidth: 'auto', objectFit: 'contain', maxHeight: '20px' }} src={signatureUrl} alt="Signature" />
                    ) : (
                      <span>&mdash;</span>
                    )}
                  </td>
                </tr>
              );
            }) : (
              <tr>
                <td colSpan={5}>
                  <span>No sign-off submissions recorded.</span>
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  )
}